"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function getValue(obj, path, defaultValue) {
    let ans = obj;
    // eslint-disable-next-line eqeqeq
    for (let i = 0; ans != null && i < path.length; i++) {
        ans = ans[path[i]];
    }
    if (defaultValue !== undefined)
        ans = defaultValue;
    return ans;
}
exports.default = getValue;
//# sourceMappingURL=getValue.js.map